import { LockClosedIcon } from '@heroicons/react/24/outline'

import { anim, stagger } from '../../../../motion'
import { Line } from '../../../../v2/kit'
import { useCopy } from '../../../i18n'
import { MaskText } from '../../stage/fx'

// Partikel strömen als Bewerbungen von links herein, am Aivy-Tor wird gemessen
const GATE = 0.42
const stream = (w, h, narrow) => ({
  type: 'stream',
  y: h * 0.5,
  band: narrow ? h * 0.1 : h * 0.13,
  gateX: w * GATE
})

export const PROCESS_PARTICLES = [
  [0.02, stream],
  [0.98, stream]
]

// Stationen auf der x-Achse (Anteil der Breite)
const STAGE_X = [0.12, GATE, 0.62, 0.78, 0.92]

export default function DmsProcess() {
  const c = useCopy('prozess')
  const s = useCopy('show')

  return (
    <div className='sc-full'>
      <div className='dms-process-head'>
        <Line at={[0, 0.05]} className='sc-eyebrow'>
          {c.eyebrow}
        </Line>
        <h2 className='sc-h2'>
          <MaskText text={s.streamTitle} at={[0.02, 0.14]} />
        </h2>
      </div>

      <div className='dms-gate' style={{ left: `${GATE * 100}%` }}>
        <div
          className='dms-gate__beam'
          style={anim({ at: [0.08, 0.16], s: 0.2, y: 0 })}
        />
        <div
          className='dms-gate__badge'
          style={anim({ at: [0.12, 0.18], y: -30 })}
        >
          <span>{c.badge}</span>
          <b>{s.gate}</b>
        </div>
      </div>

      <div className='dms-stations'>
        {c.stages.map((stage, i) => (
          <div
            key={stage}
            className={i === 1 ? 'dms-station is-gate' : 'dms-station'}
            style={{
              left: `${STAGE_X[i] * 100}%`,
              ...anim({ at: stagger(0.06, 0.02, 0.06, i), y: 20 })
            }}
          >
            <i />
            {stage}
          </div>
        ))}
      </div>

      <div className='dms-process-foot'>
        <Line at={[0.18, 0.24]} out={[0.44, 0.48]} className='dms-process-text'>
          {c.text}
        </Line>
        <div
          className='dms-privacy'
          style={anim({ at: [0.5, 0.56], out: [0.76, 0.8], y: 30 })}
        >
          <div className='dms-privacy__row'>
            {c.sent.map((item) => (
              <span key={item} className='sc-chip dms-privacy__sent'>
                {item}
              </span>
            ))}
            {c.kept.map((item) => (
              <span key={item} className='sc-chip dms-privacy__kept'>
                <LockClosedIcon width={14} height={14} />
                {item}
              </span>
            ))}
          </div>
          <p className='dms-process-text'>{c.privacy}</p>
        </div>
        <Line
          at={[0.82, 0.88]}
          className='dms-process-text dms-process-text--proof'
        >
          {c.proof}
        </Line>
      </div>
    </div>
  )
}
